
import React, { useState, useContext, useEffect } from 'react';
import '../../../styles/casedetails.css';
import { Outlet, Link, useNavigate, Navigate } from 'react-router-dom';
import { ShareContext } from '../../../context/ShareContext'
import * as Constants from '../../../constants';
import JisButton from '../../controls/jisButton';

function ViewParties({caseId, parties=null, isAction=false}) {
  const {  activePage, token, profile,frequentData,setIsExpired} = useContext(ShareContext);
          const [loading, setLoading] =useState(false);
    const [_parties, setParties] =useState(parties);
  
      useEffect(() => {
             
                /* if(parties==null){
                 onLoad();
                } */
    
            }, [parties]);
    
             const onLoad= async()=>{
                //for account registration
                try {
                  setLoading(true);
                    const resp = await fetch(`${Constants.apiUrl}/filing/case-details/${caseId}/parties`, { 
                      method: 'GET',
                      headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                      },
                    });
                    
                    const data = await resp.json();
                    if(data.code==0){
                    setParties(data.parties);
                  } else if(data.code==-10){
                      setIsExpired(true);
                  }
                   
                  } catch (error) {
                    setLoading(false);
                    console.error(error);
                    
                  }
            }
  return (
    <div>
    {isAction && <div style={{textAlign:'right'}}>
       <JisButton >Add Party</JisButton>
     </div>}  
     <div  className='table'>
        <div class="section-cases">
          <span>Parties </span>
        </div>
        <table className='case-table'>
          <thead>
            <tr>
              <th>Name</th>
              <th>Party Type</th>
              <th>Legal Counsel</th>
              <th>Phone</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {_parties.map((opt) => ( 
               <tr key={opt.id}>
              <td>{opt.firstName} {opt.lastName??''}</td>
              <td>{opt.title}</td>
              <td>{opt.legalcounsel!=null && `${opt.legalcounsel.firstName} ${opt.legalcounsel.lastName??''}` }</td>
              <td>{opt.primaryContactNumber}</td>
              <td>{opt.primaryEmail}</td>
            </tr>          
            ))}
            
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ViewParties;